import { h } from '@stencil/core';
import { getQdsIconLibrary } from '@pes-ui/utils';
import { FolderIcon } from './folder-icon-component';
export class PesFiltersNoResults {
  constructor() {
    this.handleClick = () => {
      this.resetAllClicked.emit();
    };
    this.noResultsClearLink = undefined;
    this.noResultsHeader = undefined;
    this.noResultsMessage = undefined;
  }
  render() {
    return (h("div", { class: "filters-no-results" }, h(FolderIcon, { class: "filters-no-results__search-icon" }), h("h2", { class: "filters-no-results__header" }, this.noResultsHeader), h("div", { class: "filters-no-results__message" }, this.noResultsMessage), h("qds-button", { class: "filters-no-results__clear-link", onClick: this.handleClick, size: "standard", importance: "subdued", text: this.noResultsClearLink, iconName: "arrow-up-down-circle", iconLibrary: getQdsIconLibrary("arrow-up-down-circle") })));
  }
  static get is() { return "pes-filters-no-results"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-filters-no-results.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-filters-no-results.css"]
    };
  }
  static get properties() {
    return {
      "noResultsClearLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label text of the clear link."
        },
        "attribute": "no-results-clear-link",
        "reflect": false
      },
      "noResultsHeader": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label text of the component header."
        },
        "attribute": "no-results-header",
        "reflect": false
      },
      "noResultsMessage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label text of the result meassage."
        },
        "attribute": "no-results-message",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "resetAllClicked",
        "name": "resetAllClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event emitted on link click."
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
